import * as types from './types';

const initialState = {
  plansInfo: null,
  errorPlans: false,
  loadingPlans: true
};

function plansInfoReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PLANS_INFO:
      return {
        ...state,
        errorPlans: false,
        loadingPlans: true
      };
    case types.FETCH_PLANS_INFO_COMPLETED:
      return {
        ...state,
        plansInfo: action.payload,
        loadingPlans: false
      };
    case types.FETCH_PLANS_INFO_FAILED:
      return {
        ...state,
        errorPlans: true,
        loadingPlans: false
      };
    default:
      return state;
  }
}

export { plansInfoReducer };
